export enum CommentScope {
  PROJECT = 'project',
  ALL = 'all',
}
